import React, { Component } from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";

class AutocompleteForm extends Component{
    constructor(props){
        super(props);
    }

    componentDidMount(){
        this.props.onRef(this);
    }

    render(){
        return(
            <AsyncTypeahead
                delay={600}
                disabled={this.props.disabled}
                id={this.props.id}
                inputProps={this.props.inputProps}
                isLoading={this.props.loading}
                labelKey={(option) => `${option.values}`}
                minLength={this.props.minLength}
                maxLength={this.props.maxLength}
                onChange={(e)=>this.props.handleChange(e, this.props.id)}
                onkeypress={this.props.validate}
                onSearch={(e)=>this.props.handleSearch(e)}
                options={this.props.options}
                paginationText="Mostrar mas resultados..."
                placeholder={this.props.placeholder}
                ref={this.props.reference}
                selected={this.props.selected}
                useCache={false}                
            />
        )
    }
}

export default AutocompleteForm;

AutocompleteForm.defaultProps = {
    minLength:0,
    maxLength:1000,
    disabled:false,
    inputProps:{},
    onkeypress:()=>{},
    handleSearch:()=>{},
    validate:()=>{},
    placeholder:""
}